
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 59.718 59.606"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.712 29.747c.334 16.152-13.701 30.188-29.853 29.853C13.707 59.934-.328 45.899.006 29.747-.328 13.818 13.707-.329 29.859.006c16.152-.335 30.187 13.812 29.853 29.741zM25.626 11.813v24.061h19.828v-5.013L30.75 29.747V11.813h-5.124z"}})])
          )
        }
      }
    